import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import {
  DownloadTransactionReportStackRoutes,
  DownloadTransactionReportStackScreenProps
} from '@/features/account-management/screens/download-transaction-report/type';
import { DownloadAccountTransactionReportWebScreen } from '@/features/account-management/screens/download-transaction-report/DownloadAccountTransactionReportWeb.screen';
import { DownloadAccountTransactionReportNativeScreen } from '@/features/account-management/screens/download-transaction-report/DownloadAccountTransactionReportNative.screen';

export const DownloadAccountTransactionReport: React.FC<
  DownloadTransactionReportStackScreenProps<DownloadTransactionReportStackRoutes.DownloadAccountTransactionReport>
> = ({ navigation, route }) => {
  const { onLayout, walletId } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <DownloadAccountTransactionReportNativeScreen onClose={onGoBack} onLayout={onLayout} walletId={walletId} />;
  }

  return <DownloadAccountTransactionReportWebScreen onClose={closeModal} onLayout={onLayout} walletId={walletId} />;
};
